var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Author',{attrs:{"author":_vm.author,"article_count":_vm.article_count,"post":_vm.post}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }